module.exports = __webpack_public_path__ + "img/logo_dark.94ac5d83.png";